import { useAuthStore } from '../stores/authStore';

export function usePermission(permission: string): boolean {
  const user = useAuthStore((s) => s.user);

  // Check explicit permissions loaded from /auth/me
  return user?.permissions?.includes(permission) ?? false;
}

export function useAnyPermission(permissions: readonly string[]): boolean {
  const user = useAuthStore((state) => state.user);
  return permissions.some((permission) => user?.permissions?.includes(permission) ?? false);
}

export function useHasRole(role: string): boolean {
  const user = useAuthStore((s) => s.user);
  return user?.roles?.includes(role) ?? false;
}
